import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AddProductComponent } from 'src/app/admin/sub-admin/add-product/add-product.component';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-me',
  templateUrl: './add-me.component.html',
  styleUrls: ['./add-me.component.scss'],
})
export class AddMeComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  public timeout1: any;
  constructor(
    private sharedService: SharedService,
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private customerService: CustomerService
  ) { }
  tab = '';
  openDesc = false;
  public imgUrl = environment.ImageUrl;
  public productAllProductList: Array<any> = [];
  askList: any;
  ngOnInit(): void {
    this.getAllProductList();
    this.auth.getMemberAsk().subscribe((resp) => {
      this.askList = resp.body;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.local.clearTimeout(this.timeout1)
  }

  public getAllProductList() {
    this.productAllProductList = [];
    this.customerService
      .getAllShopProduct({
        categoryId: '',
        subCategoryId: '',
      })

      .subscribe(
        (response: any) => {
          this.productAllProductList = response.body;
          //this.local.getPrimaryImages(this.productAllProductList)
        },
        (e) => {
          this.productAllProductList = [];
        }
      );
  }
  filterByType(type: string) {
    return this.productAllProductList.filter((e) => e.type === type);
  }

  openShopPopup(tab1, tab2, fun = () => { }) {
   // if (!this.sharedService.isOnMobile) {
      this.sharedService.triggerInitTabProfile(tab1);
      this.timeout1 = setTimeout(() => {
        this.sharedService.triggerInitMarketProfile(tab2);
        fun();
      }, 100);
   // }
  }

  @ViewChild('AddShop') addProductComponent: AddProductComponent;
  openListProduct(){
    
    this.addProductComponent.isRecommendedProduct = true;
    this.addProductComponent.memberShopProductType = "shop";
    this.addProductComponent.newProduct();
  }
  openRental(){
    this.addProductComponent.isRecommendedProduct = true;
    this.addProductComponent.memberShopProductType = "rental";
    this.addProductComponent.newProduct();

  }
  openDonate(){
    this.addProductComponent.isRecommendedProduct = true;
    this.addProductComponent.memberShopProductType = "bless";
    this.addProductComponent.newProduct();

  }

  openAddProduct(): () => void {
    return () => {
      document.getElementById('add-product').click();
    };
  }
}
